import { render } from "./DocumentView.vue?vue&type=template&id=76726c20&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=76726c20&lang=css"
import "./DocumentView.vue?vue&type=style&index=1&id=76726c20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76726c20"]])

export default __exports__